import { Space, Modal, Text } from '@cashfree-intl/coherent';
import styled from 'styled-components';

// Constants
import { CUSTOM_COLORS } from 'constants/colors';

//Styled
import { StyledReviewModal as StyledBankReviewModal } from 'containers/SettlementBankDetails/styled';

//Components
import ActionModal from 'components/ActionModal';

export const StyledStepChip = styled(Text)`
  background-color: ${props => props.theme.COLORS.placeholder};
  padding: 0.2rem 0.5rem;
  border-radius: 0.125rem;
`;

export const StyledAddToWhitelistModal = styled(ActionModal)`
  .action-modal-content {
    padding: 2.5rem !important;
  }
  .field input {
    max-width: 100%;
  }
  .ui.input {
    margin-bottom: 0 !important;
  }
  textarea {
    padding: 1rem;
  }
`;

export const StyledWhitelistStepTwo = styled(Space)`
  .body {
    border: 1px solid ${props => props.theme.COLORS.placeholder};
    border-radius: 0.375rem;
    padding: 1.5rem;
  }
  .alert {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    font-family: ${props => props.theme.FONTS.bold};
    .image {
      margin-right: 0.5rem !important;
    }
  }
  .title {
    font-family: ${props => props.theme.FONTS.bold};
  }
  li:before,
  li > .content {
    color: ${props => props.theme.COLORS.bodyLight} !important;
    font-size: 1rem;
  }
`;

export const StyledInactiveWebsiteModal = styled(Modal)`
  .content {
    padding: 3.75rem 2.5rem 2.5rem 2.5rem !important;
    display: flex !important;
    align-items: center;
    flex-direction: column;
  }
  .inactive-reason-textarea {
    textarea {
      padding: 1rem;
      margin-top: 0.5rem;
    }
  }
  @media only screen and (max-width: 767px) {
    img.ui.image.inactive-website {
      padding-bottom: 0px !important;
      margin-bottom: 1.5rem !important;
    }
  }
  @media only screen and (min-width: 767px) {
    .inactive-reason-textarea,
    .reason-error {
      width: 25rem;
    }
  }
`;

export const StyledWebsiteChip = styled(Space)`
  padding: 0.28rem 0.75rem;
  border: 1px solid ${CUSTOM_COLORS.F77171};
  border-radius: 1.25rem;
`;

export const StyledReviewModal = styled(StyledBankReviewModal)`
  padding-top: 5rem;
  padding-bottom: 4rem;

  .title {
    max-width: 18.75rem !important;
    text-align: center;
  }
`;

export const StyledWebsiteDetailsWrapper = styled.div`
  .field input {
    max-width: 100%;
  }
  .ui.input {
    margin-bottom: 0.75rem;
  }
  textarea {
    padding: 1rem;
    min-height: 5rem;
    background: ${props => props.theme.COLORS.disabled} !important;
    margin-bottom: 0.75rem !important;
  }
`;

export const BottomActionBar = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 2;
  width: 100%;
  padding: 1rem 2rem;
  box-shadow: 0 3px 10px rgba(43, 45, 66, 0.14);
  background: #ffffff;
`;

export const StyledAddWhitelistingDropdownWrapper = styled(Space)`
  .visible.menu,
  .selection.dropdown {
    min-width: 8.125rem !important;
  }
`;
